import { AsyncRenderErrorContentProps } from "src/components/common/async/AsyncRender.tsx";
import React from "react";
import { VerticalBox } from "src/components/common/box/VerticalBox.tsx";
import { ErrorView } from "src/components/common/errors/ErrorView.tsx";
import { ResetConfiguratorValuesButton } from "src/components/views/erp/configurator/configuratorForm/components/ResetConfiguratorValuesButton.tsx";
import i18n from "i18next";
import { PartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/partConfiguratorType.ts";
import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import { faPenToSquare } from "@fortawesome/pro-regular-svg-icons";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { getIsTestConfigurator } from "src/components/views/erp/configurator/configuratorUtils.ts";
import { TestConfiguratorContextDataForm } from "../configuratorTesting/TestConfiguratorContextDataForm.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";
import { getPartConfiguratorAgentContextData } from "src/components/views/erp/configurator/configuratorForm/utils/partConfiguratorTypeUtils.ts";

export interface ConfiguratorTreeServerErrorViewProps extends AsyncRenderErrorContentProps<unknown> {
	configuratorType: PartConfiguratorType;
	customContent: React.ReactNode | undefined;
	resetToExistingConfiguration?: () => Promise<unknown>;
	resetToDefaultValues?: () => Promise<unknown>;
}

export const ConfiguratorTreeServerErrorView = ({
	configuratorType,
	error,
	reload,
	customContent,
	resetToExistingConfiguration,
	resetToDefaultValues,
}: ConfiguratorTreeServerErrorViewProps) => {
	const { openDialog } = useGenericDialog();

	return (
		<VerticalBox
			sx={{
				flex: 1,
				gap: 2,
				margin: 2,
				alignItems: "flex-start",
			}}
		>
			<ErrorView
				additionalActions={
					<>
						<ResetConfiguratorValuesButton
							resetToExistingConfiguration={resetToExistingConfiguration}
							resetToDefaultValues={resetToDefaultValues}
							variant={"outlined"}
							label={i18n.t("reset_values")}
						/>
						{getIsTestConfigurator(configuratorType) && (
							<AsyncButton
								label={i18n.t("context_data")}
								icon={faPenToSquare}
								variant={"outlined"}
								onClick={() => {
									openDialog({
										title: i18n.t("context_data"),
										content: (
											<TestConfiguratorContextDataForm configuratorType={configuratorType} />
										),
										agentContext: {
											key: defineAgentUiContextKey(
												"erp.configurator.testConfiguratorContextData.dialog",
											),
											title: i18n.t("context_data"),
											data: getPartConfiguratorAgentContextData(configuratorType),
										},
									});
								}}
							/>
						)}
						{customContent}
					</>
				}
				error={error}
				reload={reload == null ? undefined : () => reload()}
				sx={{
					flex: "auto",
					flexGrow: 0,
					alignItems: "stretch",
					alignSelf: "stretch",
					justifySelf: "stretch",
				}}
			/>
		</VerticalBox>
	);
};
